import { navigateTo } from '../actions/navigateTo';
const handlerName = 'SearchClicked';

function handler(payload, store) {
  navigateTo('/search', store);
}

export { handlerName, handler };
